import type { RevisionFile } from '../types';
import { createEdits, randomUUID } from '../utils';

/**
 * Create a file.
 */
export function createFile(
    parts: Partial<RevisionFile> &
        Pick<RevisionFile, 'name' | 'size' | 'contentType' | 'downloadURL'>,
    byUser?: string
): RevisionFile {
    return {
        ...parts,
        edits: parts.edits ?? (byUser ? createEdits(byUser) : {}),
        id: parts.id || randomUUID(),
    };
}
